import { useMediaQuery } from "@mui/material";
import CollapsibleGridCard from "../CollapsibleGridCard";
import DashboardReminderColumns from "../../lib/TableColumns/DashboardReminderColumns";

const ReminderTable = ({ data }) => {
    const isMobile = useMediaQuery('(max-width:600px)');

    // -- Columns saved in lib/TableColumns for readability -- //
    const columns = DashboardReminderColumns({ isMobile });

    return (
        <CollapsibleGridCard
            title="Opportunities To Review & Update"
            description="List of opportunities that are allowed in the forecast and scheduled to ship in the next 4 months. These opportunities have not been marked as won and need to be monitored."
            rows={data}
            columns={columns}
            getRowId={(row) => row.lineId}
            checkboxSelection
            initialPageSize={10}
            pageSizeOptions={[10, 25, 50]}
            variantClassName="hive-reminder-table-card"
            headerClassName="hive-reminder-table-header"
            titleClassName="hive-reminder-table-title"
            toggleClassName="hive-reminder-table-toggle"
            contentClassName="hive-reminder-table-content"
            gridClassName="hive-reminder-data-grid"
            titleStyle={{ margin: 0 }}
        />
    )
}

export default ReminderTable
